<div class="view_img fs_18">
<h2>{{'ViewImage' | translate}}</h2>
<figure>
    <img [src]="image" alt="">
</figure>
</div>
